import { createFileRoute } from '@tanstack/react-router'

import { ChangeSubscriptionPage } from '~/boundedContext/subscription/pages/change-subscription-page'

export const Route = createFileRoute('/_main-layout/settings/subscription/change')({
  component: ChangeSubscriptionPage,
})
